$(document).ready(function(){
    $(document).on('click', '.mobile-menu-icon', function() {
      $('.mobile-header-nav').toggleClass('toggle');
      $('body').toggleClass('opened-drawer');
      $('.overlay-content').toggleClass('overlay');
    });

    $(document).on('click', '.close-button', function() {
      $('.mobile-header-nav').removeClass('toggle');
      $('body').removeClass('opened-drawer');
      $('.overlay-content').removeClass('overlay');
    });

     $(document).mouseup(function (e) {
      var container = $('.mobile-header-nav');
      if (!container.is(e.target) && container.has(e.target).length === 0 && $('.mobile-header-nav').hasClass('toggle')) {
        $('.mobile-header-nav').removeClass('toggle');
        $('.overlay-content').removeClass('overlay');
        $('body').removeClass('opened-drawer');
      }
     });

    $(document).on('click','.sidebar-menu .accordion',function(event) {
      console.log('.accordion');
      event.preventDefault();
      $('.accordion-plus-icon').removeClass('is-open');
      if($(this).next().hasClass('show')) {
        $(this).next().removeClass('show');
        $(this).next().slideUp(350);
        $(this).find('.accordion-plus-icon').removeClass('is-open');
      } else {
        $(this).parent().parent().find('li .dropdown-menus').removeClass('show');
        $(this).parent().parent().find('li .dropdown-menus').slideUp(350);
        $(this).next().toggleClass('show');
        $(this).next().slideToggle(350);
        $(this).find('.accordion-plus-icon').addClass('is-open');
      }
    });

     $(document).on('click','.sidebar-menu .accordion-menu',function(event) {
      event.preventDefault();
      $('.child-accordion-plus-icon').removeClass('is-open');
      if($(this).next().hasClass('show')) {
        $(this).next().removeClass('show');
        $(this).next().slideUp(350);
        $(this).find('.child-accordion-plus-icon').removeClass('is-open');
      } else {
        $(this).parent().parent().find('li .dropdown-grandchild').removeClass('show');
        $(this).parent().parent().find('li .dropdown-grandchild').slideUp(350);
        $(this).next().toggleClass('show');
        $(this).next().slideToggle(350);
        $(this).find('.child-accordion-plus-icon').addClass('is-open');
      }
    });
    
});






